import CenteredContentLayout from "@/components/layout/CenteredContentLayout";
import PageLayout from "@/components/layout/PageLayout";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_main/dashboard")({
  component: DashboardLayout,
});

function DashboardLayout() {
  return (
    <PageLayout>
      <CenteredContentLayout>
        <Outlet />
      </CenteredContentLayout>
    </PageLayout>
  );
}
